export default __webpack_public_path__ + "static/media/closet1-1440w.4cbba13c.avif";